<template>
  <h1
    :class="`mb-8 ${headlineClass}`"
  >
    {{ text }}
  </h1>
</template>
<script>
export default {
  name: 'Headline',
  props: {
    text: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    headlineClass () {
      return this.text.length > 100 ? 'sn-h4' : 'sn-h2'
    }
  }
}
</script>
